// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const polteageist: PokeData = {
  "id": 855,
  "name": "polteageist",
  "height": 2,
  "weight": 4,
  "base_experience": 178,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "mega-drain",
    "withdraw",
    "curse",
    "protect",
    "giga-drain",
    "sweet-scent",
    "shadow-ball",
    "memento",
    "astonish",
    "aromatherapy",
    "sucker-punch",
    "nasty-plot",
    "shell-smash",
    "aromatic-mist",
    "strength-sap",
    "teatime"
  ],
  "moves": [
    "curse",
    "protect",
    "shadow-ball",
    "aromatherapy",
    "confuse-ray",
    "spectral-snatch",
    "soul-sacrifice",
    "night-shade",
    "spectral-chain",
    "lick",
    "shadow-dagger",
    "poltergeist",
    "shadow-sneak"
  ],
  "evolution_chain": {
    "id": 449,
    "item": null,
    "species": [
      {
        "name": "sinistea",
        "order": 854,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "polteageist",
        "order": 855,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 854,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "cracked-pot"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 107,
    "speed": 100,
    "ability_power": 192
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
